/**
 *
 * ModalFreemiumAlertDaysRemaining
 *
 */

import React, { useState, useEffect } from "react"
import alertSvg from "images/alert.svg"
import ModalCustom from "components/ModalCustom"
import { requestUpgradeApi } from "services/requestUpgrade"

function ModalFreemiumAlertDaysRemaining() {
  const [visible, setVisible] = useState(false)
  const freemium = window.freemium()
  const showInDays = [1, 15]

  useEffect(() => {
    if (freemium) {
      setVisible(true)
    }
  }, [])

  if (!freemium || (freemium && !showInDays.includes(freemium.daysRemaining))) {
    return false
  }

  return (
    <ModalCustom
      width={487}
      className="modalAddSubdivision"
      onCancel={() => setVisible(false)}
      closable={false}
      modalOpen={visible}
      margin="0"
      onOk={() => {
        requestUpgradeApi()
        setVisible(false)
      }}
      textAlign="left"
      showFooter
      textButton="Contactar a equipo comercial"
      textCancelButton="Cerrar">
      <img src={alertSvg} className="alertIcon" alt="alert-svg" />
      <div className="text-center">
        <p>
          <b>
            ¡Faltan {freemium.daysRemaining} días para que la versión gratuita
            expire!
          </b>
        </p>
        <p>
          Para adquirir otra modalidad, no dudes en comunicarte con <br />{" "}
          nuestro equipo comercial.
        </p>
      </div>
    </ModalCustom>
  )
}

ModalFreemiumAlertDaysRemaining.propTypes = {}

export default ModalFreemiumAlertDaysRemaining
